import { useDispatch } from "react-redux";
import TableAccordion from "../../../../Components/TableAccordion";
import { TextEditor } from "../../../../Components/TextEditor";
import { showModal } from "../../../../../../../redux/actions/modal";

import styles from "./governanceAndManagement.module.scss";

interface IGovernanceAndManagement {
  data: any;
  setBusinessComments: React.Dispatch<
    React.SetStateAction<{
      business_comment: string;
      industry_comment: string;
      ownership_comment: string;
      governance_and_management_comment: string;
      borrower_info: string;
    }>
  >;
  defaultValue: string;
  readOnly: boolean;
}

const GovernanceAndManagement = ({
  data,
  setBusinessComments,
  defaultValue,
  readOnly,
}: IGovernanceAndManagement) => {
  const dispatch = useDispatch();

  const handleChange = (data: string) => {
    setBusinessComments((prev) => {
      return {
        ...prev,
        governance_and_management_comment: data,
      };
    });
  };

  const handleClick = () => {
    dispatch(
      showModal({
        modalIdentifier: "creditanalysisgovernancereview",
        dataRecord: {
          data: data,
        },
      })
    );
  };

  return (
    <div className={styles.Governance}>
      <TableAccordion
        title={<span className={styles.Title}>GOVERNANCE AND MANAGEMENT</span>}
        isDefaultOpen
      >
        <TextEditor
          onChange={handleChange}
          defaultValue={defaultValue}
          readOnly={readOnly}
        />
        <div className={styles.ActionBar}>
          <span onClick={handleClick}>View Details</span>
        </div>
      </TableAccordion>
    </div>
  );
};

export default GovernanceAndManagement;
